import { setSpecificMessage, checkItems } from "valibot";
setSpecificMessage(
  checkItems,
  (issue) => `Élément invalide: reçu ${issue.received}`,
  "fr"
);